export default __webpack_public_path__ + "dd923eb24997ae01cf5cd580e28b0707.svg";